import React from 'react'

import type { VisibleDomProps } from '../components/VisibleDom'

export interface DependentDataContextValue extends Omit<VisibleDomProps, 'filter'> {
    userId?: string
}

const DependentDataContext = React.createContext<DependentDataContextValue>({
    dataSourceList: [],
    personOptions: [],
    roleOptions: [],
    departmentOptions: [],
    availableFieldBlocksInfo: [],
    availableFilterBlocksInfo: []
})
export const DependentDataProvider = DependentDataContext.Provider
export const useDependentDataContext = () => React.useContext(DependentDataContext)
